export default __webpack_public_path__ + "static/media/fallback-image.77d71436.png";